function Dipgestestrategico(){
    return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Planeamiento Estratégico ha sido diseñado 
                    para fortalecer las capacidades analíticas y estratégicas de los profesionales, 
                    brindando herramientas modernas para la formulación, implementación, seguimiento 
                    y evaluación de planes estratégicos alineados a los objetivos institucionales.
               </p>
               <p>
                    El programa integra metodologías actualizadas de diagnóstico organizacional, 
                    análisis del entorno, formulación de objetivos estratégicos, indicadores de desempeño, 
                    gestión por resultados y toma de decisiones basada en evidencia.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias técnicas y estratégicas en los participantes 
                            para diseñar, implementar y evaluar planes estratégicos efectivos, 
                            alineando la visión institucional con acciones concretas y medibles 
                            que permitan mejorar el desempeño organizacional.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img src='/uploads/curs_contenido.jpg' alt='logo-de-metodologia' className='logo-metodologia'/>
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>
                            Escuela de Gerencia y Gestión S.A.C
                        </p>
                        <p>
                            📱 Teléfonos y WhatsApp: 913376365 / 948251685
                        </p>
                        <p>
                            📧 Correos: esscuelag@gmail.com | capacita@escuelag.com
                        </p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Diagnóstico Organizacional </li>
                    <li> 2. Análisis del Entorno </li>
                    <li> 3. Formulación de Objetivos Estratégicos </li>
                    <li> 4. Indicadores de Desempeño </li>
                    <li> 5. Gestión por Resultados </li>
                    <li> 6. Evaluación y Seguimiento Estratégico </li>
                </ul>
            </div>
        </div>
    );
}

export default Dipgestestrategico
